import script from "./SliderGallery.vue?vue&type=script&setup=true&lang=ts"
export * from "./SliderGallery.vue?vue&type=script&setup=true&lang=ts"

import "./SliderGallery.vue?vue&type=style&index=0&id=07e348e8&lang=less"

const __exports__ = script;

export default __exports__